import { Flex, Grid, Heading, Text } from "@chakra-ui/react";
import Link from "next/link";

const locations = [
  { slug: "belfast", label: "Belfast" },
  { slug: "birmingham", label: "Birmingham" },
  { slug: "brighton", label: "Brighton" },
  { slug: "cambridge", label: "Cambridge" },
  { slug: "cardiff", label: "Cardiff" },
  { slug: "edinburgh", label: "Edinburgh" },
  { slug: "glasgow", label: "Glasgow" },
  { slug: "hackney", label: "Hackney" },
  { slug: "hampstead", label: "Hampstead" },
  { slug: "ilford", label: "Ilford" },
  { slug: "kingston-upon-thames", label: "Kingston upon Thames" },
  { slug: "leeds", label: "Leeds" },
  { slug: "liverpool", label: "Liverpool" },
  { slug: "manchester", label: "Manchester" },
  { slug: "milton-keynes", label: "Milton Keynes" },
  { slug: "oxford", label: "Oxford" },
  { slug: "plymouth", label: "Plymouth" },
  { slug: "portsmouth", label: "Portsmouth" },
  { slug: "preston", label: "Preston" },
  { slug: "sheffield", label: "Sheffield" },
  { slug: "south-east-london", label: "South East London" },
  { slug: "tunbridge-wells", label: "Tunbridge Wells" },
  { slug: "whitstable", label: "Whitstable" },
];

const LocationGrid = () => (
  <Flex flexDir="column" mx={[5, "10%"]} my={10} gap={8}>
    <Heading
      as="h2"
      textStyle="h3"
      fontSize={["20px", "23px"]}
      lineHeight="30px"
      color="brand.400"
    >
      Browse therapists by location
    </Heading>

    <Grid
      gridTemplateColumns={[
        "repeat(2, minmax(0, 1fr))",
        "repeat(3, minmax(0, 1fr))",
        "repeat(4, minmax(0, 1fr))",
      ]}
      gap={3}
    >
      {locations.map(({ slug, label }) => (
        <Link key={slug} prefetch={false} href={`/counselling/${slug}`}>
          <Flex
            borderWidth={1}
            borderColor="brand.400"
            borderRadius={10}
            px={4}
            py={3}
            _hover={{ bg: "brand.50", borderColor: "brand.500" }}
            transition="all 0.15s"
          >
            <Text color="brand.400" fontWeight="medium">
              {label}
            </Text>
          </Flex>
        </Link>
      ))}
    </Grid>
  </Flex>
);

export default LocationGrid;
